// import Header from "../../components/header/Header.tsx";
// import Navbar from "../../components/navbar/Navbar.tsx";
// import Footer from "../../components/footer/Footer.tsx";
import { useEffect, useState } from "react";
import Spinner from "../../components/spinner/Spinner.tsx";
import FirstTick from "../../assets/images/first_tick.png";
import SecondTick from "../../assets/images/second_tick.png";
import Dimond from "../../assets/images/dimond.png";
import StarMen from "../../assets/images/starmen.png";
import HeartHand from "../../assets/images/hearthand.png";
import Truck from "../../assets/images/about-truck.png";
import Ticket from "../../assets/images/about-ticket.png";
import Basket from "../../assets/images/about-basket.png";
import { useLanguage } from "../../context/LanguageContext.tsx";

const AboutUs = () => {
  const {t} = useLanguage();
  const [loading, setLoading] = useState(false);

  // LOADİNG
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 400);
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      {/* <Header />
      <Navbar /> */}
      {loading && (
        <div>
          <Spinner />
        </div>
      )}
      <div className="w-10/12 my-16 mx-auto md:flex justify-between">

        <div className="md:w-[45%]">
          <div className="bg-[#FFC633] w-[150px] flex justify-center text-white p-1.5 rounded-sm ">WHO WE ARE</div>
          <p className="text-2xl font-semibold mt-4">{t('about', 'title')}</p>
          <p className="font-poppins mt-4 text-[14px]">{t('about', 'desc')}</p>

          <p className="mt-4 text-lg font-poppins text-[16px]"><a className="text-2xl text-green-500">✓✓</a>{t('about', 'text1')}</p>
          <p className="mt-4 text-lg font-poppins text-[16px]"><a className="text-2xl text-green-500">✓✓</a>{t('about', 'text2')}</p>
          <p className="mt-4 text-lg font-poppins text-[16px]"><a className="text-2xl text-green-500">✓✓</a>{t('about', 'text3')}</p>
          <p className="mt-4 text-lg font-poppins text-[16px]"><a className="text-2xl text-green-500">✓✓</a>{t('about', 'text4')}</p>
        </div>

        <div className="md:w-[45%] mt-10 md:mt-0">
          <img src={SecondTick} className="h-[24px] w-[32px] relative -left-8 top-2 object-cover" />
          <p>{t('about', 'desc2')}</p>
          <div className="flex justify-end">
            <img src={FirstTick} className="h-[24px] w-[32px] relative -right-8 bottom-8 object-cover" />
          </div>
        </div>

      </div>

      <div className="w-10/12 my-16 mx-auto flex flex-col">
        <div className="mx-auto flex-col flex items-center">
          <p className="w-[100px] h-[2.6px] bg-[#FFC633]"></p>
          <p className="text-2xl text-center text-[#FFC633] mt-3">Quality &<br></br>
            <a className="font-extrabold">Standards</a> </p>
        </div>
        <div className="w-full p-12 bg-[#fff6de] rounded-md mt-10 md:flex justify-between">
          <div className="md:w-[30%]">
            <div className="bg-[#FFC633] h-[48px] w-[48px] rounded-md justify-center items-center flex">
              <img src={Dimond} className="w-[24px] h-[24px]"></img>
            </div>
            <p className="font-semibold text-2xl mt-2">{t('about', 'subTitle1')}</p>
            <p className="mt-4">{t('about', 'subText1')}</p>
          </div>
          <div className="h-0.5 w-full my-5 md:my-0 md:w-0.5 md:h-[200px] bg-[#FFC633]"></div>
          <div className="md:w-[30%]">
            <div className="bg-[#FFC633] h-[48px] w-[48px] rounded-md justify-center items-center flex">
              <img src={StarMen} className="w-[24px] h-[24px]"></img>
            </div>
            <p className="font-semibold text-2xl mt-2">{t('about', 'subTitle2')}</p>
            <p className="mt-4">{t('about', 'subText2')}</p>
          </div>
          <div className="h-0.5 w-full my-5 md:my-0 md:w-0.5 md:h-[200px] bg-[#FFC633]"></div>
          <div className="md:w-[30%]">
            <div className="bg-[#FFC633] h-[48px] w-[48px] rounded-md justify-center items-center flex">
              <img src={HeartHand} className="w-[24px] h-[24px]"></img>
            </div>
            <p className="font-semibold text-2xl mt-2">{t('about', 'subTitle3')}</p>
            <p className="mt-4">{t('about', 'subText3')}</p>
          </div>
        </div>

        <div className="w-full p-12 border border-[#C9C9C9] rounded-md mt-10 md:flex justify-between">
          <div className="md:w-[30%] flex flex-col items-center">
            <img src={Truck} className="h-[100px] w-[120px] object-contain"></img>
            <p className="mt-4 text-center">{t('productDetail', 's1')}</p>
          </div>

          <div className="w-full h-[1px] md:w-[1px] md:h-auto bg-[#C9C9C9] my-5"></div>

          <div className="md:w-[30%] flex flex-col items-center">
            <img src={Ticket} className="h-[100px] w-[120px] object-contain"></img>
            <p className="mt-4 text-center">{t('productDetail', 's2')}</p>
          </div>

          <div className="w-full h-[1px] md:w-[1px] md:h-auto bg-[#C9C9C9] my-5"></div>

          <div className="md:w-[30%] flex flex-col items-center">
            <img src={Basket} className="h-[100px] w-[120px] object-contain"></img>
            <p className="mt-4 text-center">{t('productDetail', 's3')}</p>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default AboutUs;
